import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useMemo, useState } from 'react';
import { JoveAutocomplete } from '@jove-frontend/mui';
import { useLocalTranslation } from '@jove-frontend/uikit';
import { appendSearchCompleteAddressInfoText } from '@jove-frontend/utils';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { apiGetUKAddressDetailInfoByPostcode, apiQueryUKAddressByPostcode } from 'libs/uikit/src/api/universal';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { debounce } from 'lodash';
import { LoadingMask } from '../../Loading/LoadingMask';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PostcodeSearchCommonView = function PostcodeSearchCommonView(props) {
  var selectAddress = props.selectAddress,
      className = props.className;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState([]),
      canSelectSearchAddressList = _useState[0],
      setCanSelectSearchAddressList = _useState[1];

  var _useState2 = useState(false),
      searchAddressLoading = _useState2[0],
      setSearchAddressLoading = _useState2[1];

  var _useState3 = useState(false),
      searchAddressDetailsLoading = _useState3[0],
      setSearchAddressDetailsLoading = _useState3[1];
  /**
   * requests
   */


  var requestSearchAddressByPostCode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
      var _yield$apiQueryUKAddr, _yield$apiQueryUKAddr2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSearchAddressLoading(true);
              _context.next = 3;
              return apiQueryUKAddressByPostcode({
                postcode: query,
                limit: 50
              });

            case 3:
              _yield$apiQueryUKAddr = _context.sent;
              _yield$apiQueryUKAddr2 = _slicedToArray(_yield$apiQueryUKAddr, 1);
              res = _yield$apiQueryUKAddr2[0];
              setSearchAddressLoading(false);
              setCanSelectSearchAddressList((res === null || res === void 0 ? void 0 : res.data) || []);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestSearchAddressByPostCode(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var requestAddressDetailsInfoByPostCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var _yield$apiGetUKAddres, _yield$apiGetUKAddres2, res, _ref3, post_town, postcode;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSearchAddressDetailsLoading(true);
              _context2.next = 3;
              return apiGetUKAddressDetailInfoByPostcode({
                address_id: id
              });

            case 3:
              _yield$apiGetUKAddres = _context2.sent;
              _yield$apiGetUKAddres2 = _slicedToArray(_yield$apiGetUKAddres, 1);
              res = _yield$apiGetUKAddres2[0];
              setSearchAddressDetailsLoading(false);

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                _ref3 = res.data || {}, post_town = _ref3.post_town, postcode = _ref3.postcode;
                selectAddress === null || selectAddress === void 0 ? void 0 : selectAddress({
                  postTown: post_town,
                  postcode: postcode,
                  detailAddress: appendSearchCompleteAddressInfoText(res.data)
                });
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestAddressDetailsInfoByPostCode(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * debounce
   */


  var debouncedSearchAddressByPostcode = useMemo(function () {
    return debounce(requestSearchAddressByPostCode, 300);
  }, []);
  /**
   * methods
   */

  var postcodeInputChangeAction = function postcodeInputChangeAction(target, value) {
    debouncedSearchAddressByPostcode(value);
  };

  var selectCompanyAction = function selectCompanyAction(item) {
    requestAddressDetailsInfoByPostCode(item.value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('relative flex flex-col', className),
    children: [searchAddressDetailsLoading && /*#__PURE__*/_jsx(LoadingMask, {}), /*#__PURE__*/_jsx(JoveAutocomplete, {
      id: "quote-search-company-and-address-by-postcode",
      label: $t('kit:components.search_address_postcode'),
      getOptionLabel: function getOptionLabel(option) {
        return (option === null || option === void 0 ? void 0 : option.label) || '';
      },
      options: canSelectSearchAddressList,
      loading: searchAddressLoading,
      onInputChange: postcodeInputChangeAction,
      valueChange: selectCompanyAction,
      filterOptions: function filterOptions(options) {
        return options;
      }
    })]
  });
};